<div class="modal-detail-container hide-modal-detail">
  <div class="modal-detail">
    <div class="cls-content-lg panel">
      <div class="panel-body secoes">
        <div class="secao secao-1 informacoes-cadastrais" style="display: none;">
          <h3 class="mb-40" animate="fadeIn" delay="100">
            Complete o seu cadastro na <span class="text-primary">Pague.lá</span>!
          </h3>

          <div class="tipo-de-pessoa">
            <button (click)="changeTipoPessoa('Fisica')" [ngClass]="tipoPessoa === 'Fisica' ? 'active' : ''">Física</button>
            <button (click)="changeTipoPessoa('Juridica')" [ngClass]="tipoPessoa === 'Juridica' ? 'active' : ''">Jurídica</button>
          </div>

          <form [hidden]="tipoPessoa === 'Juridica'">
            <div class="row text-left">
              <div class="col-sm-8 col-sm-offset-2">
                <div class="form-group" animate="fadeIn" delay="300">
                  <label for="" class="control-label">CPF</label>
                  <input id="inputCpf" class="form-control" type="text" name="Cpf" mask="000.000.000-00" [(ngModel)]="conta.CpfCnpj" (keyup)="cleanErrorClass($event)">
                  <a (click)="editInput($event)" style="display: none;" id="link-InputCpf" class="input-link">Alterar</a>
                </div>
              </div>
            </div>
            <div class="row text-left">
              <div class="col-sm-8 col-sm-offset-2">
                <div class="form-group" animate="fadeIn" delay="300">
                  <label for="" class="control-label">Primeiro Nome</label>
                  <input id="inputNome" class="form-control" type="text" name="Nome" [(ngModel)]="conta.Nome" (keyup)="cleanErrorClass($event)">
                  <a (click)="editInput($event)" style="display: none;" id="link-inputNome" class="input-link">Alterar</a>
                </div>
              </div>
            </div>
            <div class="row text-left">
              <div class="col-sm-8 col-sm-offset-2">
                <div class="form-group" animate="fadeIn" delay="300">
                  <label for="" class="control-label">Sobrenome</label>
                  <input id="inputSobrenome" class="form-control" type="text" name="Sobrenome" [(ngModel)]="conta.Sobrenome" (keyup)="cleanErrorClass($event)">
                  <a (click)="editInput($event)" style="display: none;" id="link-inputSobrenome" class="input-link">Alterar</a>
                </div>
              </div>
            </div>
            <div class="row text-left">
              <div class="col-sm-8 col-sm-offset-2">
                <div class="form-group mb-40" animate="fadeIn" delay="300">
                  <label for="" class="control-label">Nome Fantasia</label>
                  <input id="inputNomeFantasia" class="form-control" type="text" name="Fantasia" [(ngModel)]="conta.Fantasia" (keyup)="cleanErrorClass($event)">
                  <a (click)="editInput($event)" style="display: none;" id="link-inputNomeFantasia" class="input-link">Alterar</a>
                </div>
              </div>
            </div>
          </form>

          <form [hidden]="tipoPessoa === 'Fisica'">
            <div class="row text-left">
              <div class="col-sm-8 col-sm-offset-2">
                <div class="form-group" animate="fadeIn" delay="300">
                  <label for="" class="control-label">CNPJ</label>
                  <input id="inputCnpj" class="form-control" type="text" name="Cnpj" mask="00.000.000/0000-00" [(ngModel)]="conta.CpfCnpj" (keyup)="cleanErrorClass($event)">
                  <a (click)="editInput($event)" style="display: none;" id="link-inputCnpj" class="input-link">Alterar</a>
                </div>
              </div>
            </div>
            <div class="row text-left">
              <div class="col-sm-8 col-sm-offset-2">
                <div class="form-group" animate="fadeIn" delay="300">
                  <label for="" class="control-label">Razão social</label>
                  <input id="inputRazaoSocial" class="form-control" type="text" name="RazaoSocial" [(ngModel)]="conta.RazaoSocial" (keyup)="cleanErrorClass($event)">
                  <a (click)="editInput($event)" style="display: none;" id="link-inputRazaoSocial" class="input-link">Alterar</a>
                </div>
              </div>
            </div>
            <div class="row text-left">
              <div class="col-sm-8 col-sm-offset-2">
                <div class="form-group" animate="fadeIn" delay="300">
                  <label for="" class="control-label">Nome Fantasia</label>
                  <input id="inputFantasia" class="form-control" type="text" name="Fantasia" [(ngModel)]="conta.Fantasia" (keyup)="cleanErrorClass($event)">
                  <a (click)="editInput($event)" style="display: none;" id="link-inputFantasia" class="input-link">Alterar</a>
                </div>
              </div>
            </div>
            <div class="row text-left">
              <div class="col-sm-8 col-sm-offset-2">
                <div class="form-group" animate="fadeIn" delay="300">
                  <label for="" class="control-label">Nome do Responsável</label>
                  <input id="inputNomeResponsavel" class="form-control" type="text" name="Nome" [(ngModel)]="conta.Nome" (keyup)="cleanErrorClass($event)">
                  <a (click)="editInput($event)" style="display: none;" id="link-inputNomeResponsavel" class="input-link">Alterar</a>
                </div>
              </div>
            </div>
            <div class="row text-left">
              <div class="col-sm-8 col-sm-offset-2">
                <div class="form-group mb-40" animate="fadeIn" delay="300">
                  <label for="" class="control-label">Sobrenome do Responsável</label>
                  <input id="inputSobrenomeResponsavel" class="form-control" type="text" name="Sobrenome" [(ngModel)]="conta.Sobrenome" (keyup)="cleanErrorClass($event)">
                  <a (click)="editInput($event)" style="display: none;" id="link-inputSobrenomeResponsavel" class="input-link">Alterar</a>
                </div>
              </div>
            </div>
          </form>
        </div>

        <div class="secao secao-2 informacoes-contato" style="display: none;">
          <h3 class="mb-40" animate="fadeIn" delay="100">
            Seus dados de <span class="text-primary">contato</span>
          </h3>

          <form>
            <div class="row text-left">
              <div class="col-sm-8 col-sm-offset-2">
                <div class="form-group" animate="fadeIn" delay="300">
                  <label for="" class="control-label">CEP</label>
                  <input id="inputCep" class="form-control" type="text" name="Cep" [(ngModel)]="endereco.Cep" mask="00000-000" (keyup)="cleanErrorClass($event)">
                  <a (click)="editInput($event)" style="display: none;" id="link-inputCep" class="input-link">Alterar</a>
                </div>
              </div>
            </div>
            <div class="row text-left">
              <div class="col-sm-8 col-sm-offset-2">
                <div class="form-group" animate="fadeIn" delay="300">
                  <label for="" class="control-label">Logradouro</label>
                  <input id="inputLogradouro" class="form-control" type="text" name="Logradouro" [(ngModel)]="endereco.Logradouro" (keyup)="cleanErrorClass($event)">
                  <a id="link-inputLogradouro" style="display: none;" class="input-link">Alterar</a>
                </div>
              </div>
            </div>
            <div class="row text-left">
              <div class="col-sm-6 col-sm-offset-2">
                <div class="form-group" animate="fadeIn" delay="300">
                  <label for="" class="control-label">Complemento</label>
                  <input id="inputComplemento" class="form-control" type="text" name="Complemento" [(ngModel)]="endereco.Complemento" (keyup)="cleanErrorClass($event)">
                  <a (click)="editInput($event)" style="display: none;" id="link-inputComplemento" class="input-link">Alterar</a>
                </div>
              </div>
              <div class="col-sm-2">
                <div class="form-group" animate="fadeIn" delay="300">
                  <label for="" class="control-label">Número</label>
                  <input id="inputNumero" class="form-control" type="text" name="Numero" [(ngModel)]="endereco.Numero" (keyup)="cleanErrorClass($event)" mask="000000">
                  <a (click)="editInput($event)" style="display: none;" id="link-inputNumero" class="input-link">Alterar</a>
                </div>
              </div>
            </div>
            <div class="row text-left">
              <div class="col-sm-8 col-sm-offset-2">
                <div class="form-group" animate="fadeIn" delay="300">
                  <label for="" class="control-label">Bairro</label>
                  <input id="inputBairro" class="form-control" type="text" name="Bairro" [(ngModel)]="endereco.Bairro" (keyup)="cleanErrorClass($event)">
                  <a (click)="editInput($event)" style="display: none;" id="link-inputBairro" class="input-link">Alterar</a>
                </div>
              </div>
            </div>
            <div class="row text-left">
              <div class="col-sm-3 col-sm-offset-2">
                <div class="form-group" animate="fadeIn" delay="300">
                  <label for="" class="control-label">Estado</label>
                  <div class="dropdown">
                    <button class="btn btn-default dropdown-toggle" type="button" id="dropdownMenu1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">{{ endereco.Estado || 'UF' }}<span class="caret"></span>
                    </button>
                    <ul class="dropdown-menu uf" aria-labelledby="dropdownMenu1">
                      <li (click)="selectUf(uf)" *ngFor="let uf of ufs"><a>{{ uf }}</a></li>
                    </ul>
                  </div>
                  <a id="link-inputEstado" style="display: none;" class="input-link">Alterar</a>
                </div>
              </div>
              <div class="col-sm-5">
                <div class="form-group" animate="fadeIn" delay="300">
                  <label for="" class="control-label">Cidade</label>
                  <input id="inputCidade" class="form-control" type="text" name="Cidade" [(ngModel)]="endereco.Cidade" (keyup)="cleanErrorClass($event)">
                  <a (click)="editInput($event)" style="display: none;" id="link-inputCidade" class="input-link">Alterar</a>
                </div>
              </div>
            </div>
            <div class="row text-left">
              <div class="col-sm-8 col-sm-offset-2">
                <div class="form-group mb-40" animate="fadeIn" delay="300">
                  <label for="" class="control-label">Telefone</label>
                  <input id="inputTelefone" class="form-control" mask="(00) 00000-0000" type="text" name="Telefone" [(ngModel)]="conta.Telefone" (keyup)="cleanErrorClass($event)">
                  <a (click)="editInput($event)" style="display: none;" id="link-inputTelefone" class="input-link">Alterar</a>
                </div>
              </div>
            </div>
          </form>
        </div>

        <div class="secao secao-3 informacoes-bancarias" style="display: none;">
          <h3 animate="fadeIn" delay="100">
            Seus dados <span class="text-primary">bancários</span>
          </h3>
          <h4 class="mb-40" animate="fadeIn" delay="100" style="font-weight: 200; text-align: center;">
            A conta em que você irá receber seus pagamentos.<br>Deve ser de mesma titularidade do cadastro.
          </h4>

          <form>
            <div class="row text-left">
              <div class="col-sm-8 col-sm-offset-2">
                <div class="form-group" animate="fadeIn" delay="300">
                  <label for="" class="control-label">Banco</label>
                  <div class="dropdown">
                    <button class="btn btn-default dropdown-toggle" type="button" id="dropdownMenuBanco" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">{{ banco && banco.name ? banco.name : 'Selecione' }}<span class="caret"></span>
                    </button>
                    <ul class="dropdown-menu bancos-dropdown">
                      <li (click)="selectBanco(banco)" *ngFor="let banco of bancos"><a>{{ banco.codigo + ' ' + banco.name }}</a></li>
                    </ul>
                  </div>
                  <a (click)="editInput($event)" style="display: none;" id="link-inputBanco" class="input-link">Alterar</a>
                </div>
              </div>
            </div>
            <div class="row text-left">
              <div class="col-sm-6 col-sm-offset-2">
                  <div class="form-group" animate="fadeIn" delay="300">
                    <label for="" class="control-label">Tipo de Conta</label>
                    <div class="dropdown">
                      <button class="btn btn-default dropdown-toggle" type="button" id="dropdownMenuTipoConta" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">{{ tipoConta && tipoConta.name ? tipoConta.name : 'Selecione' }}<span class="caret"></span>
                      </button>
                      <ul class="dropdown-menu">
                        <li (click)="selectTipoConta(tipoConta)" *ngFor="let tipoConta of tiposConta"><a>{{ tipoConta.name }}</a></li>
                      </ul>
                    </div>
                    <a (click)="editInput($event)" style="display: none;" id="link-inputBanco" class="input-link">Alterar</a>
                  </div>
                </div>
              <div class="col-sm-2">
                <div class="form-group" animate="fadeIn" delay="300">
                  <label for="" class="control-label">Agência</label>
                  <input id="inputAgencia" class="form-control" type="text" name="Agencia" [(ngModel)]="informacaoBancaria.Agencia" (keyup)="cleanErrorClass($event)">
                  <a (click)="editInput($event)" style="display: none;" id="link-inputAgenciaDigito" class="input-link">Alterar</a>
                </div>
              </div>
            </div>
            <div class="row text-left">
              <div class="col-sm-6 col-sm-offset-2">
                <div class="form-group mb-40" animate="fadeIn" delay="300">
                  <label for="" class="control-label">Conta Corrente</label>
                  <input id="inputConta" class="form-control" type="text" name="Conta" [(ngModel)]="informacaoBancaria.NumeroConta" (keyup)="cleanErrorClass($event)">
                  <a (click)="editInput($event)" style="display: none;" id="link-inputConta" class="input-link">Alterar</a>
                </div>
              </div>
              <div class="col-sm-2">
                <div class="form-group mb-40" animate="fadeIn" delay="300">
                  <label for="" class="control-label">Dígito</label>
                  <input id="inputDigito" class="form-control" type="text" name="Conta" [(ngModel)]="informacaoBancaria.ContaDigito" (keyup)="cleanErrorClass($event)">
                  <a (click)="editInput($event)" style="display: none;" id="link-inputDigito" class="input-link">Alterar</a>
                </div>
              </div>
            </div>
          </form>
        </div>

        <div class="secao secao-4 documentos" style="display: none;">
          <h3 class="mb-40" animate="fadeIn" delay="100">
            Envie seus <span class="text-primary">documentos</span>
          </h3>

          <form *ngIf="tipoPessoa === 'Fisica'">
            <div class="row text-left">
              <div class="col-xs-7 col-xs-offset-2">
                <div class="form-group">
                  <label class="control-label">Identificação</label>
                  <label [ngClass]="!filesEmpty.identificacao ? 'disabled' : ''" class="input" for="arquivo-identificacao">{{ fileNames.identificacao || 'Selecionar arquivo...' }}</label>
                  <input [disabled]="!filesEmpty.identificacao ? true : false" (change)="selectFile($event)" class="file" id="arquivo-identificacao" name="file" type="file">
                </div>
              </div>
              <div class="col-xs-1">
                <div class="icon-camera">
                  <i *ngIf="!filesEmpty.identificacao" class="fa fa-camera" [ngClass]="!filesEmpty.identificacao ? 'disabled' : ''"></i>
                  <i *ngIf="filesEmpty.identificacao" (click)="openWebcamModal('identificacao')" class="fa fa-camera" [ngClass]="!filesEmpty.identificacao ? 'disabled' : ''"></i>
                </div>
              </div>
              <div class="col-xs-7 col-xs-offset-2">
                <div class="form-group">
                  <label class="control-label">Atividade</label>
                  <label [ngClass]="!filesEmpty.atividade ? 'disabled' : ''" class="input" for="arquivo-atividade">{{ fileNames.atividade || 'Selecionar arquivo...' }}</label>
                  <input [disabled]="!filesEmpty.atividade ? true : false" (change)="selectFile($event)" class="file" id="arquivo-atividade" name="file" type="file">
                </div>
              </div>
              <div class="col-xs-1">
                <div class="icon-camera">
                  <i *ngIf="!filesEmpty.atividade" class="fa fa-camera" [ngClass]="!filesEmpty.atividade ? 'disabled' : ''"></i>
                  <i *ngIf="filesEmpty.atividade" (click)="openWebcamModal('atividade')" class="fa fa-camera" [ngClass]="!filesEmpty.atividade ? 'disabled' : ''"></i>
                </div>
              </div>
              <div class="col-xs-7 col-xs-offset-2">
                <div class="form-group mb-40">
                  <label class="control-label">Residência</label>
                  <label [ngClass]="!filesEmpty.residencia ? 'disabled' : ''" class="input" for="arquivo-residencia">{{ fileNames.residencia || 'Selecionar arquivo...' }}</label>
                  <input [disabled]="!filesEmpty.residencia ? true : false" (change)="selectFile($event)" class="file" id="arquivo-residencia" name="file" type="file">
                </div>
              </div>
              <div class="col-xs-1">
                <div class="icon-camera">
                  <i *ngIf="!filesEmpty.residencia" class="fa fa-camera" [ngClass]="!filesEmpty.residencia ? 'disabled' : ''"></i>
                  <i *ngIf="filesEmpty.residencia" (click)="openWebcamModal('residencia')" class="fa fa-camera" [ngClass]="!filesEmpty.residencia ? 'disabled' : ''"></i>
                </div>
              </div>
            </div>
          </form>

          <form *ngIf="tipoPessoa === 'Juridica'">
              <div class="row text-left">
                <div class="col-xs-7 col-xs-offset-2">
                  <div class="form-group">
                    <label class="control-label">Identificação</label>
                    <label [ngClass]="!filesEmpty.identificacao ? 'disabled' : ''" class="input" for="arquivo-identificacao">{{ fileNames.identificacao || 'Selecionar arquivo...' }}</label>
                    <input [disabled]="!filesEmpty.identificacao ? true : false" (change)="selectFile($event)" class="file" id="arquivo-identificacao" name="file" type="file">
                  </div>
                </div>
                <div class="col-xs-1">
                  <div class="icon-camera">
                    <i *ngIf="!filesEmpty.identificacao" class="fa fa-camera" [ngClass]="!filesEmpty.identificacao ? 'disabled' : ''"></i>
                    <i *ngIf="filesEmpty.identificacao" (click)="openWebcamModal('identificacao')" class="fa fa-camera" [ngClass]="!filesEmpty.identificacao ? 'disabled' : ''"></i>
                  </div>
                </div>
                <div class="col-xs-7 col-xs-offset-2">
                  <div class="form-group">
                    <label class="control-label">Atividade</label>
                    <label [ngClass]="!filesEmpty.atividade ? 'disabled' : ''" class="input" for="arquivo-atividade">{{ fileNames.atividade || 'Selecionar arquivo...' }}</label>
                    <input [disabled]="!filesEmpty.atividade ? true : false" (change)="selectFile($event)" class="file" id="arquivo-atividade" name="file" type="file">
                  </div>
                </div>
                <div class="col-xs-1">
                  <div class="icon-camera">
                    <i *ngIf="!filesEmpty.atividade" class="fa fa-camera" [ngClass]="!filesEmpty.atividade ? 'disabled' : ''"></i>
                    <i *ngIf="filesEmpty.atividade" (click)="openWebcamModal('atividade')" class="fa fa-camera" [ngClass]="!filesEmpty.atividade ? 'disabled' : ''"></i>
                  </div>
                </div>
                <div class="col-xs-7 col-xs-offset-2">
                  <div class="form-group">
                    <label class="control-label">Residência</label>
                    <label [ngClass]="!filesEmpty.residencia ? 'disabled' : ''" class="input" for="arquivo-residencia">{{ fileNames.residencia || 'Selecionar arquivo...' }}</label>
                    <input [disabled]="!filesEmpty.residencia ? true : false" (change)="selectFile($event)" class="file" id="arquivo-residencia" name="file" type="file">
                  </div>
                </div>
                <div class="col-xs-1">
                  <div class="icon-camera">
                    <i *ngIf="!filesEmpty.residencia" class="fa fa-camera" [ngClass]="!filesEmpty.residencia ? 'disabled' : ''"></i>
                    <i *ngIf="filesEmpty.residencia" (click)="openWebcamModal('residencia')" class="fa fa-camera" [ngClass]="!filesEmpty.residencia ? 'disabled' : ''"></i>
                  </div>
                </div>
                <div class="col-xs-7 col-xs-offset-2">
                  <div class="form-group mb-40">
                    <label class="control-label">CNPJ</label>
                    <label [ngClass]="!filesEmpty.cnpj ? 'disabled' : ''" class="input" for="arquivo-cnpj">{{ fileNames.cnpj || 'Selecionar arquivo...' }}</label>
                    <input [disabled]="!filesEmpty.cnpj ? true : false" (change)="selectFile($event)" class="file" id="arquivo-cnpj" name="file" type="file">
                  </div>
                </div>
                <div class="col-xs-1">
                  <div class="icon-camera">
                    <i *ngIf="!filesEmpty.cnpj" class="fa fa-camera" [ngClass]="!filesEmpty.cnpj ? 'disabled' : ''"></i>
                    <i *ngIf="filesEmpty.cnpj" (click)="openWebcamModal('cnpj')" class="fa fa-camera" [ngClass]="!filesEmpty.cnpj ? 'disabled' : ''"></i>
                  </div>
                </div>
              </div>
            </form>
        </div>

        <div class="secao secao-5 informacoes-cartao" style="display: none;">
          <h3 class="mb-40" animate="fadeIn" delay="100">
            Conclua seu <span class="text-primary">pagamento</span>
          </h3>
          <div class="text-implantacao">
            <span class="text-primary">Implantação __________________ R$ 390,00</span>
          </div>
          <form autocomplete="off" class="panel-body2 ng-untouched ng-pristine ng-valid" id="form-checkout" *ngIf="formCartao">
            <div class="row mt-10">
              <div class="col-sm-8 col-sm-offset-2">
                <div class="form-group has-feedback text-left">
                  <label class="control-label" for="cartao">Nº Cartão de Crédito</label>
                  <div class="form-group has-feedback text-left">
                    <input [attr.disabled]="!notPaidMembership ? true : null" (keyup)="nextInput($event)" autocomplete="off" class="form-control cartao-credito" mask="0000 0000 0000 0000" placeholder="XXXX XXXX XXXX XXXX" type="text" (bandeira)="setBrand($event)" [(ngModel)]="card.Numero" name="cartao" id="cartao" appBandeiraCartao>
                    <figure class="bandeira-cartao default form-control-feedback"></figure>
                  </div>
                  <figure class="bandeira-cartao default form-control-feedback"></figure>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-2 col-sm-offset-2">
                <div class="form-group text-left">
                  <label class="control-label" for="validademes">Validade</label>
                  <input [attr.disabled]="!notPaidMembership ? true : null" (keyup)="nextInput($event)" autocomplete="off" class="form-control" mask="00" maxlength="2" placeholder="mês" type="text" [(ngModel)]="validadeMesCartao" id="validademes" name="validademes">
                </div>
              </div>
              <div class="col-sm-2">
                <div class="form-group text-left">
                  <label class="control-label" for="validadeano">&nbsp;</label>
                  <input [attr.disabled]="!notPaidMembership ? true : null" (keyup)="nextInput($event)" autocomplete="off" class="form-control" mask="00" maxlength="2" placeholder="ano" type="text" [(ngModel)]="validadeAnoCartao" id="validadeano" name="validadeano">
                </div>
              </div>
              <div class="col-sm-3 col-sm-offset-1">
                <div class="form-group text-left">
                  <label class="control-label" for="codseguranca">Cód. Segurança</label>
                  <input [attr.disabled]="!notPaidMembership ? true : null" (keyup)="nextInput($event)" autocomplete="off" class="form-control" mask="000" maxlength="3" placeholder="XXX" type="text" [(ngModel)]="card.CodigoSeguranca" id="codseguranca" name="codseguranca">
                </div>
              </div>
            </div>
            <div class="row mb-40">
              <div class="col-sm-8 col-sm-offset-2">
                <div class="form-group text-left">
                  <label class="control-label" for="nometitular">Nome do Titular
                    <small> (como escrito no cartão)</small>
                  </label>
                  <input [attr.disabled]="!notPaidMembership ? true : null" (keyup)="nextInput($event)" autocomplete="off" class="form-control" maxlength="50" placeholder="Nome Sobrenome" type="text" [(ngModel)]="card.NomeComprador" id="nometitular" name="nometitular">
                </div>
              </div>
            </div>
          </form>

          <div *ngIf="success" id="resultado-sucesso" class="panel-body2 mb-40 col-sm-offset-2 col-sm-8">
            <div class="mensagem-sucesso">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 70 70">
                <title>Aprovada!</title>
                <g id="41c310f0-3cde-4914-9ee4-e4952dc4cf98" data-name="Círculo Aprovado">
                  <circle cx="35" cy="35" r="25" style="fill:none;stroke:#00caff;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px"
                  />
                </g>
                <g id="752bc498-d218-4c7d-b07b-03fcc9fc5d57" data-name="Ok Aprovado">
                  <polyline points="21.74 29.96 33.7 41.88 68.21 15.36" style="fill:none;stroke:#00caff;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px"
                  />
                </g>
              </svg>
              <h3>{{msgSuccess}}</h3>
            </div>
            <div class="info-transacao-aprovada">
              <div class="dados-aprovados">
                <span>
                  Cartão
                </span>
                <span class="text-bold info-cartao">
                  <span id="numero-cartao">XXXX XXXX XXXX {{card.Numero.length === 4 ? card.Numero : getLastDigits(card.Numero)}}</span>
                  <figure [ngClass]="'bandeira-cartao ' + getClassBandeiraCartao(card.Numero)"></figure>
                </span>
              </div>
              <hr>
              <div class="dados-aprovados">
                <span>
                  Validade
                </span>
                <span id="validade-cartao" class="text-bold">{{validadeMesCartao + '/20' + validadeAnoCartao}}</span>
              </div>
              <hr>
              <div class="dados-aprovados">
                <span>
                  Titular
                </span>
                <span id="titular-cartao" class="text-bold">{{card.NomeComprador}}</span>
              </div>
              <hr>
              <div class="dados-aprovados">
                <span>
                  Comprovante (Tid)
                </span>
                <span id="numero-comprovante" class="text-bold">{{transaction.Transacao.Tid}}</span>
              </div>
              <hr>
              <div class="dados-aprovados">
                <span>
                  <b>Valor</b>
                </span>
                <span id="valor" class="text-bold">{{transaction.Transacao.Valor.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}}</span>
              </div>
            </div>
          </div>

          <div *ngIf="error" class="panel-body2 mb-40" id="resultado-reprovado">
            <div class="resultado-reprovado">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 70 70">
                <title>Transação Reprovada</title>
                <g id="f32c9904-9a49-4b84-a96b-1205778d7e8e" data-name="Camada 2">
                  <circle cx="35" cy="35" r="25" style="fill:none;stroke:#e95753;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px" />
                </g>
                <g id="5db0cdd3-dede-4fdb-87f7-b5ef7f2d2bf1" data-name="Camada 3">
                  <line x1="24.39" y1="24.39" x2="45.61" y2="45.61" class="linha-2" style="fill:none;stroke:#e95753;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px" />
                </g>
                <g id="fb91e5a3-f581-43de-b27f-420a0e4d440d" data-name="Camada 4">
                  <line x1="45.61" y1="24.39" x2="24.39" y2="45.61" class="linha-1" style="fill:none;stroke:#e95753;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px" />
                </g>
              </svg>
              <h3 id="erro-principal" class="text-danger"></h3>
            </div>
            <div class="erro-reprovacao">
              <span id="msg-erro" class="text-bold">{{ msgError }}</span>
            </div>
          </div>
        </div>

        <div class="secao secao-6 finished" style="display: none;">
          <h3 class="mb-40" animate="fadeIn" delay="100">
            Cadastro atualizado com
            <span class="text-primary">sucesso!</span>
          </h3>
          <div class="icone-sucesso">
            <div class="icone">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 70 70" width="140" class="">
                <defs>
                  <linearGradient id="a" x1="17" y1="33.82" x2="69" y2="33.82" gradientUnits="userSpaceOnUse">
                    <stop offset="0" stop-color="#4379ff"/><stop offset="1" stop-color="#8e42ff"/>
                  </linearGradient>
                  <linearGradient id="b" x1="6.5" y1="35" x2="63.5" y2="35" xlink:href="#a"/>
                </defs>
                <title>ilustra-check</title>
                <path class="path-1" d="M18 35.47 29 46.17 68 21.47" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" stroke="url(#a)"/>
                <path class="path-2" d="M61,16.75C58.45,11.26,52,8.89,39.18,8.89c-17,0-23.69,3.13-27.85,14.27C8.88,29.77,7.5,40.21,7.5,45.1c0,12.88,8,16,23.32,16,16,0,21.94-2.09,26.45-9.76,2.32-4.41,3.89-10.86,4.65-17.33a81.89,81.89,0,0,0,.58-9.46A17.92,17.92,0,0,0,61,16.75Z" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" stroke="url(#b)"/>
              </svg>
            </div>
          </div>
        </div>

        <div class="row btns">
          <div class="col-sm-4 mb-30 btn-back" animate="fadeIn" delay="900">
            <button (click)="previousSection()" class="btn btn-invertido" type="submit">Voltar</button>
          </div>
          <div class="mb-30 btn-next" animate="fadeIn" delay="900">
            <button [ngClass]="isOutline ? 'btn-outline btn btn-primary btn-registrar' : 'btn btn-primary btn-registrar'" (click)="nextSection()" type="submit">Avançar</button>
          </div>
        </div>

        <div class="navegacao" *ngIf="!isFinished">
          <div class="ponto" (click)="changePage($event)" *ngFor="let section of sections; index as i" [attr.data-index]="section" [ngClass]="i === 0 ? 'ativo' : ''"></div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-detail-mask"></div>
</div>

<!--
<app-modal-detail-doc class="modal-info" [showModal]="showWebcamModal" (eventClose)="closeWebcamModal()">
  <div *ngIf="showWebcamModal" class="webcam" (resize)="onResize($event)">
      <webcam [allowCameraSwitch]="false" [hidden]="webcamImage" [width]="width" [trigger]="triggerObservable" (imageCapture)="handleImage($event)"></webcam>

      <img [hidden]="!webcamImage" [src]="webcamImage">

      <button *ngIf="!webcamImage" (click)="snapshot()" class="btn btn-primary btn-webcam"><i class="fa fa-camera"></i></button>

      <button *ngIf="webcamImage" (click)="accept()" class="btn btn-primary btn-webcam accept"><i class="fa fa-check"></i></button>
      <button *ngIf="webcamImage" (click)="cancel()" class="btn btn-primary btn-webcam cancel"><i class="fa fa-close"></i></button>
  </div>
</app-modal-detail-doc> -->
